import {
  getCoordinate,
  getSelectedArea,
  getMode,
  getPanoramaId,
  getZoom,
} from './url';

import { setCoordinate, setPanoramaById } from '../store/actions';
import { setMapUi, setLoadingScreen } from '../store/ui';
import { setSelectedArea, setZoom } from '../store/map';
import { setPanoramaId } from '../store/panorama';

/**
 * Create handler for window pop state.
 * @param {redux.Store} store Redux store.
 * @return {function} handler.
 */
export default (store) => () => {
  const isUpdateUrl = false;
  const isMapUI = getMode() === 'map';
  const panoramaId = getPanoramaId();

  store.dispatch(setCoordinate(getCoordinate(), isUpdateUrl));
  store.dispatch(setSelectedArea(getSelectedArea(), isUpdateUrl));
  store.dispatch(setMapUi(isMapUI, isUpdateUrl));
  store.dispatch(setZoom(getZoom(), isUpdateUrl));

  if (!isMapUI && panoramaId) {
    store.dispatch(setPanoramaById(panoramaId, isUpdateUrl));
  } else if (store.getState().panorama.id !== '') {
    store.dispatch(setPanoramaId('', isUpdateUrl));
  }

  if (!window.location.search) {
    store.dispatch(setLoadingScreen(true));
  }
};
